// This file was generated using `pay js:run gql-v1 --type=query --name=RetieveIpGeocode --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

import {gql} from '@sail/data';
import {useV1Query} from '@stripe-internal/data-v1';

import type {GraphQlDocument} from '@sail/data';

import type {
  V1QueryOptions,
  V1QueryOptionsWithoutVariables,
  V1QueryReturn,
  V1PermissionToken,
} from '@stripe-internal/data-v1/types';

import type {
  Exact,
  InputMaybe,
  OpenapiGetV1IpGeocodeInput,
  V1ContextInput,
} from '@stripe-internal/data-v1/schema/types';

const doc = gql`
  query RetieveIpGeocodeQuery(
    $input: OpenapiGetV1IpGeocodeInput
    $v1Context: V1ContextInput!
  ) {
    v1IpGeocode(input: $input, v1Context: $v1Context) {
      lat
      lon
    }
  }
`;

export const retieveIpGeocodeQuery: RetieveIpGeocodeQueryDocument = doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const retieveIpGeocodeQueryOptions: V1QueryOptionsWithoutVariables<RetieveIpGeocodeQueryDocument> =
  {
    // expectedErrors: [],
    // mutedErrors: [],
    // fetchPolicy: 'cache-first',
    // ...
  };

export default function useRetieveIpGeocodeQuery(
  options: V1QueryOptions<RetieveIpGeocodeQueryDocument>,
): V1QueryReturn<RetieveIpGeocodeQueryDocument> {
  return useV1Query(
    retieveIpGeocodeQuery,
    Object.assign({}, retieveIpGeocodeQueryOptions, options),
  );
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type RetieveIpGeocodeQueryVariables = Exact<{
  input?: InputMaybe<OpenapiGetV1IpGeocodeInput>;
  v1Context: V1ContextInput;
}>;

export type RetieveIpGeocodeQueryData = {
  readonly __typename: 'Query';
  readonly v1IpGeocode: {
    readonly __typename: 'OpenapiGeoIpAddressGeocoding';
    readonly lat: string | null;
    readonly lon: string | null;
  } | null;
};

const retieveIpGeocodeQueryPermissions = {} as const;

doc.permissions = retieveIpGeocodeQueryPermissions;

export type RetieveIpGeocodeQueryPermissions = V1PermissionToken<
  typeof retieveIpGeocodeQueryPermissions
>;

export type RetieveIpGeocodeQueryDocument = GraphQlDocument<
  RetieveIpGeocodeQueryData,
  RetieveIpGeocodeQueryVariables,
  RetieveIpGeocodeQueryPermissions
>;
